export const TileType = {
  NORMAL: 'NORMAL',
  PENALTY: 'PENALTY',
  THEFT: 'THEFT',
  MINIGAME: 'TURNO',
  START: 'GUANACASTE',
  END: 'SAN_JOSE',
  BONUS: 'BONUS',
  SURPRISE: 'SORPRESA',
  FAIR: 'FERIA',
  PACT: 'PACTO'
};

export const BOARD_PATH = [
  { id: 0, type: TileType.START, label: 'Inicio', description: '¡Empieza la aventura!' },
  { id: 1, type: TileType.NORMAL, label: 'Casilla 2', description: '' },
  { id: 2, type: TileType.NORMAL, label: 'Casilla 3', description: '' },
  { id: 3, type: TileType.NORMAL, label: 'Casilla 4', description: '' },
  { id: 4, type: TileType.NORMAL, label: 'Casilla 5', description: '' },
  { id: 5, type: TileType.NORMAL, label: 'Casilla 6', description: '' },
  { id: 6, type: TileType.NORMAL, label: 'Casilla 7', description: '' },
  { id: 7, type: TileType.NORMAL, label: 'Casilla 8', description: '' },
  { id: 8, type: TileType.NORMAL, label: 'Casilla 9', description: '' },
  { id: 9, type: TileType.NORMAL, label: 'Casilla 10', description: '' },
  { id: 10, type: TileType.NORMAL, label: 'Casilla 11', description: '' },
  { id: 11, type: TileType.NORMAL, label: 'Casilla 12', description: '' },
  { id: 12, type: TileType.NORMAL, label: 'Casilla 13', description: '' },
  { id: 13, type: TileType.NORMAL, label: 'Casilla 14', description: '' },
  { id: 14, type: TileType.NORMAL, label: 'Casilla 15', description: '' },
  { id: 15, type: TileType.NORMAL, label: 'Casilla 16', description: '' },
  { id: 16, type: TileType.NORMAL, label: 'Casilla 17', description: '' },
  { id: 17, type: TileType.NORMAL, label: 'Casilla 18', description: '' },
  { id: 18, type: TileType.NORMAL, label: 'Casilla 19', description: '' },
  { id: 19, type: TileType.NORMAL, label: 'Casilla 20', description: '' },
  { id: 20, type: TileType.NORMAL, label: 'Casilla 21', description: '' },
  { id: 21, type: TileType.NORMAL, label: 'Casilla 22', description: '' },
  { id: 22, type: TileType.NORMAL, label: 'Casilla 23', description: '' },
  { id: 23, type: TileType.NORMAL, label: 'Casilla 24', description: '' },
  { id: 24, type: TileType.END, label: 'Meta', description: '¡Meta final!' }
];

export const PLAYER_COLORS = ['#ef4444', '#3b82f6', '#22c55e', '#eab308'];

export const COSTARRICANISMOS = [
  { word: "BRETE", meaning: "Trabajo o empleo." },
  { word: "TUANIS", meaning: "Algo muy bueno, excelente o 'cool'." },
  { word: "BOMBETA", meaning: "Persona que quiere ser el centro de atención." },
  { word: "DIAY", meaning: "Expresión multiuso." },
  { word: "HARINA", meaning: "Dinero." },
  { word: "MEJENGA", meaning: "Partido de fútbol informal." },
  { word: "ZAGUATE", meaning: "Perro de la calle." },
  { word: "YODO", meaning: "Café." },
  { word: "PURA VIDA", meaning: "Todo bien." }
];

export const ADIVINANZAS = [
  { riddle: "Agua pasa por mi casa, cate de mi corazón.", answer: "El aguacate", options: ["El aguacate", "El coco", "La piña"] },
  { riddle: "Blanco es, gallina lo pone, con aceite se fríe y con pan se come.", answer: "El huevo", options: ["El huevo", "La tortilla", "El queso"] },
  { riddle: "Soy chiquito como un ratón y cuido la casa como un león.", answer: "El candado", options: ["El candado", "El perro", "El duende"] },
  { riddle: "Tengo escamas y no soy pez, tengo corona y no soy rey.", answer: "La piña", options: ["La piña", "La granadilla", "El banano"] },
  { riddle: "Cien amigos tengo, todos en una tabla, si yo no los toco, ellos no me hablan.", answer: "La marimba", options: ["La marimba", "El piano", "La guitarra"] }
];

export const LEGENDS_DATA = {
  mico_malo: {
    id: 'mico_malo',
    name: 'El Mico Malo',
    description: 'Un mono travieso y diabólico que aparece en los árboles para molestar a los viajeros.',
    history: 'En los pueblos se cuenta que no es mono de monte, sino bruja o diablo disfrazado. Dicen que se asoma en los techos y en los árboles, grande como un becerro, con ojos rojos como brasas. Al que va solo por veredas oscuras lo hace perderse y le deja huellas raras, de esas que no son de ningún animal conocido.',
    effect: 'Roba 5 tamales al jugador.',
    icon: '/mico.webp'
  },
  carreta_sin_bueyes: {
    id: 'carreta_sin_bueyes',
    name: 'La Carreta sin Bueyes',
    description: 'Una carreta fantasmagórica que avanza sola, haciendo un ruido estruendoso.',
    history: 'Cuenta la gente vieja que en el San José de antes vivía una bruja enamorada del muchacho más gallardo. El joven, muy de misa, la rechazó, pero ella lo amarró con encantos y vivieron juntos por años. Al morir el hombre, la bruja pidió los santos oficios y el cura se los negó; entonces enyugó los bueyes, montó el ataúd en la carreta y se fue al templo con escoba y machete. Los bueyes se frenaron al oír al sacerdote, pero la bruja no, y desde entonces carreta y difunto vagan por los caminos, con el chirrido de las ruedas arrastradas por la mano del mismísimo diablo.',
    effect: 'Pierdes 2 tamales y retrocedes 2 casillas. Elige un rival: pierde 1 tamal y retrocede 1 casilla.',
    icon: '/bueyes.webp'
  },
  la_segua: {
    id: 'la_segua',
    name: 'La Segua',
    description: 'Una mujer hermosa que se transforma en un monstruo con cara de calavera de caballo.',
    history: 'La Segua espanta a los infieles y a los borrachos. En caminos solitarios se aparece como mujer bellísima, de cabello negro, pidiendo que la lleven. El hombre, embobado, avanza un trecho y entonces ella cambia: se vuelve calavera de yegua con ojos de fuego y dientes enormes. Dicen que se le pega a la espalda y lo deja loco para siempre.',
    effect: '¡Adivina el Costarriqueñismo o pierde 5 tamales por el susto!',
    icon: '/segua.webp'
  },
  la_llorona: {
    id: 'la_llorona',
    name: 'La Llorona',
    description: 'El alma en pena de una mujer que busca a sus hijos perdidos cerca de los ríos.',
    history: 'Dicen que una mujer, cegada por la pena, arrojó a su hijo al río. El remordimiento la condenó y ahora anda vestida de blanco, a la orilla del agua, con el pelo suelto y el lamento que corta el alma: Ay, mi hijo. Si el grito suena lejos, está cerca; si suena cerca, mejor ni voltee.',
    effect: '¡Debes dar la MITAD de tus tamales a un jugador que elijas!',
    icon: '/llorona.webp'
  },
  tulevieja: {
    id: 'tulevieja',
    name: 'La Tulevieja',
    description: 'Una anciana con sombrero de tule, alas de murciélago y patas de ave.',
    history: 'La Tulevieja es mitad mujer y mitad ave, con sombrero de tule y alas caídas. Cuentan que sus pechos gotean leche y hormigas rojas se alimentan de ellos. Anda buscando al hijo perdido entre ríos y potreros; a veces castiga a los hombres lujuriosos y otras veces amamanta a bebés abandonados, como si la culpa la obligara a salvarlos.',
    effect: '¡Puedes retroceder 3 espacios o quedarte si pagas 3 tamales!',
    icon: '/tule.webp'
  },
  dueno_monte: {
    id: 'dueno_monte',
    name: 'El Dueño del Monte',
    description: 'Un gigante cubierto de pelo que protege la naturaleza y a los animales.',
    history: 'El Dueño del Monte es el guardián de la selva. Unos dicen que es un gigante cubierto de pelo y hojas; otros, que es un grito que retumba y no se deja ver. No es malo, pero castiga al cazador sin necesidad y al que tala por ambición. Puede borrar los caminos y hacer que el intruso camine en círculos hasta que se arrepienta.',
    effect: 'Lanza el dado para ver cuántos tamales pierdes. ¡Usa "Rice and Beans" para evitarlo!',
    icon: '/dueno.webp'
  },
  los_duendes: {
    id: 'los_duendes',
    name: 'Los Duendes',
    description: 'Pequeños seres elementales que habitan en los cafetales y bosques.',
    history: 'En los pueblos dicen que los duendes no son malos, solo muy traviesos. Les gustan los niños, sobre todo los no bautizados, y los engañan con juguetes o dulces brillantes. Si el chiquillo los sigue, lo llevan al monte para jugar por siempre. A los adultos les tiran piedras o les hacen bromas pesadas.',
    effect: '¡Elige a un rival! Si no adivina tu adivinanza, pierde 2 tamales. ¡Si adivina, los pierdes tú!',
    icon: '/duendes.webp'
  },
  sanatorio_duran: {
    id: 'sanatorio_duran',
    name: 'Sanatorio Durán',
    description: 'Un antiguo hospital donde habitan sombras y ecos de lamentos.',
    history: 'En las montañas frías de Cartago está el Sanatorio Durán. Dicen los vecinos que allí se ven monjas fantasma y una niña que juega en las gradas cuando cae la neblina. El aire se enfría de golpe, se oyen lamentos y las sombras caminan solas por pasillos que ya no tienen enfermos.',
    effect: '¡Las sombras te desorientan! Eres teletransportado a una casilla aleatoria ANTES de esta.',
    icon: '/duran.webp'
  },
  brujas_escazu: {
    id: 'brujas_escazu',
    name: 'Las Brujas de Escazú',
    description: 'Hechiceras que aparecen entre la neblina para confundir a los viajeros.',
    history: 'Escazú es la tierra de las brujas, así lo cuenta la gente. Hablan de hechiceras con saberes viejos, capaces de transformar a la gente en animales o mover piedras con la mente. La más famosa fue Zárate. Dicen que se reunían en los cerros para hacer aquelarres, lanzar hechizos y guardar secretos que aún hoy nadie se atreve a revelar.',
    effect: '¡Lanza el dado! Las brujas invocan la maldición de otra leyenda al azar.',
    icon: '/brujas.webp'
  },
  iztaru: {
    id: 'iztaru',
    name: 'Pasajera Fantasmal de la Carretera',
    description: 'El espectro de una mujer que aparece de madrugada pidiendo que la lleven.',
    history: 'De madrugada aparece la pasajera, a la orilla de la carretera, haciendo señas. Se sube a un taxi o a un carro particular y pide que la lleven cerca del cementerio. Al llegar, señala una casa para que paguen, mientras ella se baja o entra al camposanto. Cuando el chofer cobra, la familia dice que la muchacha murió hace años; y en otras versiones, se desvanece del asiento sin dejar rastro.',
    effect: '¡Intercambias tu posición con el jugador que va de último!',
    icon: '/fantasma.webp'
  },
  hormigas_nandayure: {
    id: 'hormigas_nandayure',
    name: 'Hormigas de Nandayure',
    description: 'Hormigas feroces que atacan en masa.',
    history: 'Cuentan que la princesa Nandayure vio a sus sirvientas hacer desorden y pidió ayuda al Gran Espíritu. Como castigo, las convirtió en hormigas zompopas, y les dio una misión eterna: olfatear la maldad. Si un agricultor o visitante trae malas intenciones, las hormigas llegan en montón y le acaban la cosecha.',
    effect: '¡Pierdes 2 tamales y todos los demás pierden 1!',
    icon: '/hormiga.webp'
  },
  rio_oro: {
    id: 'rio_oro',
    name: 'La Mina Ahogada de Río Oro',
    description: 'Una mina perdida bajo el río, con tesoros y espíritus guardianes.',
    history: 'En Río Oro, Santa Ana, se cuenta la historia de la Mina Ahogada. Dicen que extranjeros llegaron en busca de oro entre 1821 y 1840, y usaron esclavos indígenas y negros para excavar. La mina se inundó y quedó tragada por la tierra, mezclada con el cauce del río. En la zona se hablan de muertes misteriosas, luces y susurros que cuidan el oro escondido. El río quedó como guardia de esa tragedia y de los secretos que nadie se atreve a sacar.',
    effect: 'Adivinanza grupal: si la mayoría falla, retrocedes 2 casillas.',
    icon: '/riooro.webp'
  },
  copito: {
    id: 'copito',
    name: 'El Copito',
    description: 'Un guardián blanco que cuida a los viajeros entre la neblina.',
    history: 'Cuentan que cuando caminas por montañas con neblina, el Copito te acompaña a lo lejos. Parece un animalito blanco y peludo, como un copo de nieve, que viene dando saltitos hasta que sales del bosque. Dicen que una vez protegió a un hombre que iba a caballo: el Copito se transformó en un oso blanco gigantesco y con un solo golpe detuvo al maleante que lo iba a atacar. Por eso muchos dicen que cuando hay neblina, más vale no meterse con los que el Copito cuida.',
    effect: 'Ganas 2 tamales, das 1 a otro jugador y puedes mover 1 casilla adelante, atrás o quedarte.',
    icon: '/copito.webp'
  },
  oso_caballo: {
    id: 'oso_caballo',
    name: 'El Oso Caballo',
    description: 'Una criatura del monte con cuerpo de oso y cabeza de caballo.',
    history: 'La leyenda del Oso Caballo habla de un ser enorme y peludo que protege el bosque. Dicen que tiene cabeza de caballo, ojos rojos y garras que destrozan a los cazadores imprudentes. Muchos lo asocian con el oso hormiguero gigante, que se defiende con sus garras cuando se siente amenazado. Ese temor creció con historias de un guardián que castiga a quienes dañan la naturaleza, como si fuera el alma de un cazador condenado.',
    effect: 'Puedes pagar 5 tamales o todos regresan a la casilla 1.',
    icon: '/oso.webp'
  },
  padre_sin_cabeza: {
    id: 'padre_sin_cabeza',
    name: 'El Padre sin Cabeza',
    description: 'Un sacerdote fantasmagórico que camina sin su cabeza, cargando un rosario.',
    history: 'Se aparece en ruinas de iglesias antiguas o bajo higuerones cerca de sitios sagrados. Unos dicen que fue decapitado por defender lo santo; otros, que murió en pecado y quedó penando. Anda buscando su cabeza, y quien lo ve se queda helado, sin voz para contar lo que sintió.',
    effect: 'Paga 3 tamales o la meta se bloquea por 2 turnos.',
    icon: '/padre.webp'
  },
  isla_san_lucas: {
    id: 'isla_san_lucas',
    name: 'La Isla San Lucas',
    description: 'Una isla-prisión rodeada de sombras y leyendas.',
    history: 'En el Golfo de Nicoya se habla de San Lucas como isla de castigo. Fue prisión por muchos años y quedó marcada por el dolor. Dicen que en los pabellones se oyen susurros y lamentos, y que en la celda de castigo se ven sombras de presos que no encontraron descanso. La novela "La isla de los hombres solos" dejó vivo ese recuerdo y la gente asegura que hasta el diablo rondaba cuando reinaba la crueldad. Antes fue la Isla de Chara, refugio indígena, y en las noches algunos cuentan que piratas escondieron tesoros en sus cuevas. Todo eso hace que la isla tenga un aura pesada y misteriosa.',
    effect: 'Todos votan a quién juzgar. El más votado pierde 2 tamales; si hay empate, todos pierden 3.',
    icon: '/sanlucas.webp'
  },
  ninguenta: {
    id: 'ninguenta',
    name: 'La Nigüenta',
    description: 'Una figura de buena suerte que simboliza prosperidad y protección.',
    history: 'La Nigüenta es una niña sacándose una nigua del pie, un símbolo popular de buena fortuna. Representa superación y protección contra problemas, y aunque su origen es debatido, se cree que llegó de Europa a inicios del siglo XX y se volvió un amuleto muy querido en Costa Rica.',
    effect: 'Recibes 7 tamales.',
    icon: '/ninguenta.webp'
  },
  la_mona_costa_rica: {
    id: 'la_mona_costa_rica',
    name: 'La Mona de Costa Rica',
    description: 'Una criatura mítica que se esconde entre las leyendas.',
    history: 'La Mona no es mico, es mujer bruja. Con rezos oscuros y volteretas se quita la piel humana y se vuelve un mono grande que corre por los techos, haciendo escándalo para asustar o vigilar. Dicen que si la hieres en su forma animal, al día siguiente la mujer aparece con la misma herida y ya queda descubierta.',
    effect: 'Antes de cada turno, puede intercambiar su posición con otra leyenda al azar.',
    icon: '/mona.webp'
  }
};

export const PROVINCES = [
  'San José',
  'Alajuela',
  'Cartago',
  'Heredia',
  'Guanacaste',
  'Puntarenas',
  'Limón'
];
